export { default } from './OutputCard';
